import FieldStoryPoints from "../../../generic/story-points/story-points"
import FieldConfig from "../../../proto/field-config"
import FieldItemModelStoryPointsCalculated_TableCell from "./render/table/table-cell"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import {ItemModelV2_CalculatedValues} from "../../../../model2/item2/calculated/@type";

export default class FieldItemModelStoryPointsCalculated extends FieldStoryPoints {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                              = "Story points"
        this.label                                  = "Story points"

        this.hasCalculatedValues                    = true

        this.renderComponents.tableCell             = FieldItemModelStoryPointsCalculated_TableCell
        this.renderComponents.tableCellCalculated   = FieldItemModelStoryPointsCalculated_TableCell
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem: ItemModelV2) => {
                    const dataByAggregateFunc = listItem.calculated.dataByAggregateFunction[this.fieldId]
                    const calculatedValues: ItemModelV2_CalculatedValues = dataByAggregateFunc?.[_.keys(dataByAggregateFunc)[0] as keyof {}] // take first property from dataByAggregateFunc

                    return calculatedValues?.total.value || 0
                }
            ],
            directions  : [sort]
        }
    }

    /** AGGREGATE **/
    getAggregateOptions() {return [
        AggregateFunctionType.SUM,
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.SUM
    }
}